import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { Toaster } from "@/components/ui/toaster";
import { TooltipProvider } from "@/components/ui/tooltip";
import { AuthProvider } from "@/contexts/AuthContext";
import { CurrencyProvider } from "@/contexts/CurrencyContext";
import "@/i18n";

import Index from "./pages/Index";
import Login from "./pages/Login";
import Register from "./pages/Register";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import Buy from "./pages/Buy";
import Rent from "./pages/Rent";
import Projects from "./pages/Projects";
import PropertyDetail from "./pages/PropertyDetail";
import ProjectDetail from "./pages/ProjectDetail";
import Dashboard from "./pages/Dashboard";
import DeveloperApplication from "./pages/DeveloperApplication";
import AgencyApplication from "./pages/AgencyApplication";
import MortgageCalculator from "./pages/MortgageCalculator";
import CostCalculator from "./pages/CostCalculator";
import Agencies from "./pages/Agencies";
import AgencyDetail from "./pages/AgencyDetail";
import DeveloperDetail from "./pages/DeveloperDetail";
import Plots from "./pages/Plots";
import PlotDetail from "./pages/PlotDetail";
import Commercial from "./pages/Commercial";
import CommercialDetail from "./pages/CommercialDetail";
import Advertise from "./pages/Advertise";
import Blogs from "./pages/Blogs";
import BlogDetail from "./pages/BlogDetail";
import News from "./pages/News";
import NewsDetail from "./pages/NewsDetail";
import Forum from "./pages/Forum";
import ForumTopic from "./pages/ForumTopic";
import NotFound from "./pages/NotFound";
import FeedValidator from "./pages/FeedValidator";
import AdEventsVerification from "./pages/AdEventsVerification";
import AgenciesAdPreview from "./pages/AgenciesAdPreview";
import AgencyTierDebug from "./pages/AgencyTierDebug";
import AreaGuides from "./pages/AreaGuides";
import AreaGuideDetail from "./pages/AreaGuideDetail";
import ContactUs from "./pages/ContactUs";
import SocietyMap from "./pages/SocietyMap";
import AVM from "./pages/AVM";
import HomeAdvisoryAI from "./pages/HomeAdvisoryAI";
import EthioPropertyInvest from "./pages/EthioPropertyInvest";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <AuthProvider>
          <CurrencyProvider>
          <Routes>
            <Route path="/" element={<Index />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/buy" element={<Buy />} />
            <Route path="/rent" element={<Rent />} />
            <Route path="/projects" element={<Projects />} />
            <Route path="/projects/:id" element={<ProjectDetail />} />
            <Route path="/agencies" element={<Agencies />} />
            <Route path="/agencies/:id" element={<AgencyDetail />} />
            <Route path="/developers/:slug" element={<DeveloperDetail />} />
            <Route path="/property/:id" element={<PropertyDetail />} />
            <Route path="/developer-application" element={<DeveloperApplication />} />
            <Route path="/agency-application" element={<AgencyApplication />} />
            <Route path="/plots" element={<Plots />} />
            <Route path="/plot/:id" element={<PlotDetail />} />
            <Route path="/commercial" element={<Commercial />} />
            <Route path="/commercial/:id" element={<CommercialDetail />} />
            <Route path="/mortgage-calculator" element={<MortgageCalculator />} />
            <Route path="/cost-calculator" element={<CostCalculator />} />
            <Route path="/advertise" element={<Advertise />} />
            <Route path="/area-guides" element={<AreaGuides />} />
            <Route path="/area-guides/:citySlug/:neighborhoodSlug" element={<AreaGuideDetail />} />
            <Route path="/contact" element={<ContactUs />} />
            <Route path="/society-map" element={<SocietyMap />} />
            <Route path="/avm" element={<AVM />} />
            <Route path="/home-advisory-ai" element={<HomeAdvisoryAI />} />
            <Route path="/ethio-property-invest" element={<EthioPropertyInvest />} />
            <Route path="/blogs" element={<Blogs />} />
            <Route path="/blogs/:slug" element={<BlogDetail />} />
            <Route path="/news" element={<News />} />
            <Route path="/news/:slug" element={<NewsDetail />} />
            <Route path="/forum" element={<Forum />} />
            <Route path="/forum/:id" element={<ForumTopic />} />
            <Route path="/dashboard/*" element={<Dashboard />} />
            <Route path="/dev/feed-validator" element={<FeedValidator />} />
            <Route path="/dev/ad-events" element={<AdEventsVerification />} />
            <Route path="/dev/agencies-preview" element={<AgenciesAdPreview />} />
            <Route path="/dev/agency-tier" element={<AgencyTierDebug />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
          </CurrencyProvider>
        </AuthProvider>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
